export const GET_DETRACTIONS = 'GET_DETRACTIONS';
export const GET_DETRACTION = 'GET_DETRACTION';
export const FLAG_GETTING_DETRACTIONS = 'FLAG_GETTING_DETRACTIONS';
export const FLAG_DETRACTION_ACTIVITY = 'FLAG_DETRACTION_ACTIVITY';
export const CLEAR_DETRACTION = 'CLEAR_DETRACTION';
export const CLEAR_DETRACTIONS = 'CLEAR_DETRACTIONS';
